import axios from 'axios';

export const requestCanceller = () => {
const cancelToken = axios.CancelToken;
const source = cancelToken.source();
	return {
		cancel : () => source.cancel('Request Cancelled'),
		signal : source.token,
		isCancel : (err) => axios.isCancel(err)

	};
}